import type { UnitActivity } from "@/lib/api/courseUnits";

export const ACTIVITY_DETAIL_MAX = 500;
export type DraftActivity = { id: string; label: string; minutes: string; detail: string };
export const draftActivities = (activities: UnitActivity[] = []): DraftActivity[] => activities.map(activity => ({
  id: activity.id, label: activity.label,
  minutes: activity.minutes == null ? "" : String(activity.minutes), detail: activity.detail ?? "",
}));
export const savedActivities = (activities: DraftActivity[]): UnitActivity[] => activities.map(activity => ({
  id: activity.id, label: activity.label.trim(), minutes: activity.minutes === "" ? null : Number(activity.minutes),
  detail: activity.detail.trim() || null,
}));
export const activitiesValid = (activities: DraftActivity[]) => activities.length <= 40 && activities.every(activity =>
  !!activity.label.trim() && activity.label.length <= 200 && activity.detail.trim().length <= ACTIVITY_DETAIL_MAX
  && (activity.minutes === "" || (/^\d+$/.test(activity.minutes) && Number(activity.minutes) <= 1440)));

export function planTiming(activities: UnitActivity[], startsAt?: string | null, endsAt?: string | null) {
  const planned = activities.reduce((total, activity) => total + (activity.minutes ?? 0), 0);
  const untimed = activities.filter(activity => activity.minutes == null).length;
  const duration = startsAt && endsAt ? (Date.parse(endsAt) - Date.parse(startsAt)) / 60000 : NaN;
  const budget = Number.isFinite(duration) && duration >= 0 ? duration : null;
  return { planned, untimed, budget, remaining: budget === null ? null : budget - planned };
}
